
import { supabase } from "@/integrations/supabase/client";

// Make a call to a lead using Plivo
export const makeCall = async (
  leadId: string, 
  phoneNumber: string, 
  messageUrl: string
): Promise<{ success: boolean; callId?: string; error?: string }> => {
  try {
    const { data, error } = await supabase.functions.invoke("make-call", {
      body: { leadId, phoneNumber, messageUrl },
    });

    if (error) throw error;
    if (!data.success) throw new Error(data.error || "Failed to initiate call");

    return { success: true, callId: data.callId };
  } catch (error) {
    console.error("Error making call:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "An unknown error occurred" 
    };
  }
};
